module.exports = __webpack_public_path__ + "img/public/SiteIcons/adminTableDotIcon.svg?87da72f1";